import { jsx as _jsx } from "react/jsx-runtime";
import { useFormControl } from '@mui/material/FormControl';
import styled from 'styled-components';
import { formHelperTextStyles, useTheme } from '@famly/mf_theme';
import { Box, createBox } from '@famly/mf_layout_box';
// MUI's default `error.main` and `text.disabled`. The MF theme never set a palette, so these are what
// MUI's `FormHelperText` drew, and its `disabled` style override never reached the element.
const ERROR_COLOR = '#d32f2f';
const DISABLED_COLOR = 'rgba(0, 0, 0, 0.38)';
const StyledText = styled(createBox({ component: 'p', textAlign: 'left' })) `
    ${formHelperTextStyles}
    color: ${props => props.$color};
`;
const HelperText = ({ children, error: errorFromProps, disabled: disabledFromProps, ...rest }) => {
    const { colorPalette } = useTheme();
    // Like MUI, a prop left undefined falls back to the surrounding `FormControl`, which is how the MF
    // `FormControl` turns its error message red without passing `error`.
    const formControl = useFormControl();
    const error = errorFromProps !== null && errorFromProps !== void 0 ? errorFromProps : formControl === null || formControl === void 0 ? void 0 : formControl.error;
    const disabled = disabledFromProps !== null && disabledFromProps !== void 0 ? disabledFromProps : formControl === null || formControl === void 0 ? void 0 : formControl.disabled;
    // Error wins over disabled, as MUI's `.Mui-error` rule came after its `.Mui-disabled` one.
    let color = colorPalette.n300;
    if (error) {
        color = ERROR_COLOR;
    }
    else if (disabled) {
        color = DISABLED_COLOR;
    }
    return (_jsx(StyledText, { "$color": color, ...rest, children: children === ' ' ? (
        // A lone space keeps the line's height. `notranslate` stops Google Translate from
        // breaking the zero-width space.
        _jsx(Box, { component: "span", className: "notranslate", children: '​' })) : (children) }));
};
export const FormErrorText = (props) => _jsx(HelperText, { ...props });
export const FormHelperText = (props) => _jsx(HelperText, { ...props, error: false });
